<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="Change password"
    :closeOnBgClick="false"
  >
    <template slot="body" class="content">
      <BForm :elements="form" @valid="form.valid = $event"></BForm>
    </template>
    <template slot="footer" class="content">
      <div
        :disabled="!form.valid || isLoading"
        :class="{ 'is-loading': isLoading }"
        class="button is-primary"
        @click="save()"
      >
        Change
      </div>
      <div class="button" @click="hide()">Close</div>
    </template>
  </Modal>
</template>

<script>
import { postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
  },
  components: {
    BForm: () => import("@/components/singles/BForm/component.vue"),
    Modal: () => import("@/components/main/Modal.vue"),
  },

  data() {
    return {
      isLoading: false,
      form: {
        valid: false,
        inputs: [
          {
            icon: "mdi-lock",
            name: "username",
            placeholder: "Old password",
            type: "password",
            label: null,
            validation: "required",
            value: "",
            focus: true,
          },
          {
            icon: "mdi-lock",
            label: null,
            name: "password",
            placeholder: "New password",
            type: "password",
            validation: "required|min:8|confirmed:confirmation",
            value: "",
          },
        ],
      },
    };
  },
  created() {},

  mounted() {},
  methods: {
    async save() {
      if (this.form.valid && !this.isLoading) {
        try {
          this.isLoading = true;
          await postApi("changepassword", {
            oldPassword: this.form.inputs[0].value,
            newPassword: this.form.inputs[1].value,
          });

          this.hide();

          this.$helpers.notify(
            "Success",
            "The password has been changed.",
            "success"
          );
        } catch ({ response }) {
          if (response.status == 403) {
            //$scope.oldPassword = "";
            this.$helpers.notify(
              "No match",
              "The old password is incorrect.",
              "info"
            );
          } else if (response.status == 500) {
            this.$helpers.notify(
              "Error",
              "Internal server error, please try again later.",
              "danger"
            );
          } else if (response.status == 400) {
            this.$helpers.notify("Error", "Missing parameter.", "danger");
          }
        }

        this.isLoading = false;
      }
    },
    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    },
  },
};
</script>
